module.exports = __webpack_public_path__ + "img/19.53ae3bb8.png";